class NewAnganceMenu extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.na-menu__toggle');
    this.items = Array.from(this.querySelectorAll('.na-menu__item'));
    this.triggers = Array.from(this.querySelectorAll('.na-menu__trigger'));
    this.closeTimer = null;

    this.toggle?.addEventListener('click', () => this.toggleMobileMenu());
    this.triggers.forEach((trigger) => {
      const item = trigger.closest('.na-menu__item');

      trigger.addEventListener('click', () => {
        item.classList.contains('is-open') ? this.closeItem(item) : this.openItem(item);
      });

      item.addEventListener('mouseenter', () => {
        if (!this.isDesktop()) return;
        window.clearTimeout(this.closeTimer);
        this.openItem(item);
      });

      item.addEventListener('mouseleave', () => {
        if (!this.isDesktop()) return;
        this.closeTimer = window.setTimeout(() => this.closeItem(item), 120);
      });
    });

    document.addEventListener('click', this.onDocumentClick);
    document.addEventListener('keydown', this.onKeyDown);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
    document.removeEventListener('keydown', this.onKeyDown);
  }

  isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  toggleMobileMenu() {
    const isOpen = this.classList.toggle('is-mobile-open');
    this.toggle?.setAttribute('aria-expanded', String(isOpen));

    if (!isOpen) {
      this.close();
    }
  }

  openItem(item) {
    this.items.forEach((otherItem) => {
      if (otherItem !== item) this.closeItem(otherItem);
    });

    const trigger = item.querySelector('.na-menu__trigger');
    const panel = item.querySelector('.na-menu__panel');

    item.classList.add('is-open');
    trigger?.setAttribute('aria-expanded', 'true');
    panel?.removeAttribute('hidden');
  }

  closeItem(item) {
    const trigger = item.querySelector('.na-menu__trigger');
    const panel = item.querySelector('.na-menu__panel');

    item.classList.remove('is-open');
    trigger?.setAttribute('aria-expanded', 'false');
    panel?.setAttribute('hidden', '');
  }

  close() {
    this.items.forEach((item) => this.closeItem(item));
    this.classList.remove('is-mobile-open');
    this.toggle?.setAttribute('aria-expanded', 'false');
  }

  onDocumentClick = (event) => {
    if (!this.contains(event.target)) {
      this.close();
    }
  };

  onKeyDown = (event) => {
    if (event.key === 'Escape') {
      this.close();
    }
  };
}

if (!customElements.get('newangance-menu')) {
  customElements.define('newangance-menu', NewAnganceMenu);
}
